import { ReactNode, useCallback, useMemo } from 'react';
import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellLink } from '../../table/cells/CellLink';

export const ModelCellAttachmentDownloadBase = ({
  children,
  getValue,
  ...props
}: TableInheritedProps & { children?: ReactNode }) => {
  const syntheticGetValue = useCallback(
    () => getValue!()?.url_attachment,
    [getValue]
  );
  const linkText = useMemo(
    () => children || getValue!()?.display_name,
    [children, getValue]
  );

  return (
    <CellLink getValue={syntheticGetValue} {...props}>
      {linkText}
    </CellLink>
  );
};

export const ModelCellAttachmentDownload = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellAttachmentDownload',
    ModelCellAttachmentDownloadBase,
    props
  );
